import React, {Suspense} from 'react'
import useQueryLoaderNow from '../../../hooks/useQueryLoaderNow'
import {LoaderSize} from '../../../types/constEnums'
import {Loader} from '../../../utils/relay/renderLoader'
import teamSettingsQuery, {

} from '../../../__generated__/TeamSettingsQuery.graphql'
import TeamSettings from './TeamSettings/TeamSettings'





const TeamSettingsRoot = ({teamId}) => {
  const queryRef = useQueryLoaderNow(teamSettingsQuery, {teamId})
  return (
    React.createElement(Suspense, { fallback: React.createElement(Loader, { size: LoaderSize.PANEL,} ),}
      , queryRef && React.createElement(TeamSettings, { queryRef: queryRef,} )
    )
  )
}

export default TeamSettingsRoot
